var exports = {
  "AS": "x61f99309--e97df2--item",
  "A1": "x61f99309--e97df2--_active",
  "zH": "x61f99309--e97df2--details",
  "Te": "x61f99309--e97df2--texts",
  "vE": "x61f99309--e97df2--preview-image",
  "hJ": "x61f99309--e97df2--counter",
};

module.exports = exports;
